import { useEffect, useState } from 'react';

import { Input } from '@iwoca/orion';

import styles from './PaymentsSearch.module.css';

export const PaymentsSearch = ({
  onChange,
}: {
  onChange: (query: string) => void;
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  // TODO: Worth removing and only search on pressing return
  useEffect(() => {
    const getPaylinks = setTimeout(() => {
      if (!searchValue) return;

      onChange(searchValue);
    }, 200);

    return () => clearInterval(getPaylinks);
  }, [searchValue, onChange]);

  return (
    <div className={styles.searchFieldContainer}>
      <Input
        iconLeft="zoomOutline"
        name="searchField"
        id="searchField"
        value={searchValue}
        onChange={(event) => {
          setSearchValue(event.target.value);
        }}
        placeholder="Search references or clients..."
        className={styles.searchField}
      />
    </div>
  );
};
